<p-fieldset legend="Atendimento à LRF">
  <div class="row">
    <div class="col-12">
      <label for="lrf" class="required col-form-label float-left mr-3">Espécie de despesa</label>
      <select [compareWith]="compareFn" id="lrf" class="form-control col-4" [(ngModel)]="entidade.lrf"
        [ngModelOptions]="{standalone: true}">
        <option *ngFor="let item of opcoesLRF" [ngValue]="item.id">{{item.nome}}</option>
      </select>
    </div>
  </div>

  <p-fieldset legend="Estimativa trienal" *ngIf="entidade.lrf === '16'">
    <div class="row">
      <label class="required col-12 col-form-label">
        Foi demonstrada a existência da estimativa trienal (com premissas e metodologia de cálculo utilizado) do impacto
        orçamentário-financeiro (no exercício em que deva entrar em vigor e nos dois subseqüentes), conforme inciso I do
        Art.16 da LRF?
      </label>
      <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12"
        [(ngModel)]="entidade.LRFArtigo16.EstimativaTrienal" [ngModelOptions]="{standalone: true}">
        <ng-template let-opcao>
          <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
        </ng-template>
      </p-selectButton>
    </div>
  </p-fieldset>
  <p-fieldset legend="Adequação ao planejamento" *ngIf="entidade.lrf === '16'">
    <div class="row">
      <label class="required col-12 col-form-label">
        Há declaração do ordenador de despesa de que o aumento tem adequação orçamentária e financeira com a lei
        orçamentária anual (LOA) e compatibilidade com o Plano Plurianual (PPA) e com a Lei de Diretrizes Orçamentárias
        (LDO), conforme inc. II do Art.16 da LRF?
      </label>
      <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12"
        [(ngModel)]="entidade.LRFArtigo16.AdequacaoPlano" [ngModelOptions]="{standalone: true}">
        <ng-template let-opcao>
          <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
        </ng-template>
      </p-selectButton>
    </div>
  </p-fieldset>

  <p-fieldset legend="Metas de resultado" *ngIf="entidade.lrf === '17'">
    <div class="row">
      <label class="required col-12 col-form-label">
        O ato de criação da despesa corrente de caráter continuado está acompanhado de comprovação de que a despesa
        aumentada ou criada não afetará as metas de Resultados previstas no Anexo de Metas Fiscais (artigo 17, §2º da
        LRF)?
      </label>
      <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12"
        [(ngModel)]="entidade.LRFArtigo17.MetasResultado" [ngModelOptions]="{standalone: true}">
        <ng-template let-opcao>
          <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
        </ng-template>
      </p-selectButton>
    </div>
  </p-fieldset>
  <p-fieldset legend="Medidas de compensação" *ngIf="entidade.lrf === '17'">
    <div class="row">
      <label class="required col-12 col-form-label">
        O ato de criação da despesa corrente de caráter continuado está acompanhado de medidas de compensação em virtude
        de seus efeitos financeiros, para os próximos exercícios, seja através do aumento permanente da receita
        (elevação de alíquotas, ampliação da base de cálculo ou majoração ou criação de tributo ou arrecadação) ou pela
        redução permanente da despesa (artigo 17, §2º e 3º da LRF)?
      </label>
      <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12"
        [(ngModel)]="entidade.LRFArtigo17.MedidasCompensacao" [ngModelOptions]="{standalone: true}">
        <ng-template let-opcao>
          <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
        </ng-template>
      </p-selectButton>
    </div>
  </p-fieldset>
  <p-fieldset legend="Previsão no PPA e na LDO" *ngIf="entidade.lrf === '17'">
    <div class="row">
      <label class="required col-12 col-form-label">
        Existe previsão da despesa obrigatória de caráter continuado criada no PPA e na LDO? (artigo 17, §4º da LRF)?
      </label>
      <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12"
        [(ngModel)]="entidade.LRFArtigo17.PrevisaoPpaLdo" [ngModelOptions]="{standalone: true}">
        <ng-template let-opcao>
          <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
        </ng-template>
      </p-selectButton>
    </div>
  </p-fieldset>
</p-fieldset>